<template>
  <i class="tm-diag-tracks">
    <i
      v-for="(track, i) in trackLayer.visual"
      :key="track.guid"
      class="-tracks"
    >
      🎬<i class="i" v-text="`[${i}]`" />
      <i
        :class="numberClassObj(track.data.displayStartTime)"
        v-text="track.data.displayStartTime"
      />
      <i
        :class="numberClassObj(track.data.displayEndTime)"
        v-text="track.data.displayEndTime"
      />
      <i
        :class="numberClassObj(track.data.displayDuration)"
        v-text="`(${track.data.displayDuration})`"
      />
      <i
        v-if="track.data.limit.fragment"
        v-text="`/${visualFragmentDurationDelta(track)}/`"
      />
    </i>
    <i>
      ∆D = ∑(E-S) - ∑(D) =
      <span :class="['n', { ok: deltaOfSums === 0 }]" v-text="deltaOfSums" />
    </i>

    <i v-for="(track, i) in trackLayer.audio" :key="track.guid" class="-tracks">
      🎙<i class="i" v-text="`[${i}]`" />
      <i
        :class="numberClassObj(track.data.displayStartTime)"
        v-text="track.data.displayStartTime"
      />
      <i
        :class="numberClassObj(track.data.displayEndTime)"
        v-text="track.data.displayEndTime"
      />
      <i
        :class="numberClassObj(track.data.relativeStartTime)"
        v-text="track.data.relativeStartTime"
      />
      <i
        :class="numberClassObj(track.data.relativeEndTime)"
        v-text="track.data.relativeEndTime"
      />
      <i v-text="`/${audioFragmentDurationDelta(track)}/`" />
    </i>
    <i>
      <span>∑ = {{ maxLayerDuration }}</span>
      (🎬 =
      <span
        class="n"
        :class="{
          e: maxLayerDuration === trackLayer.visualDuration,
        }"
        v-text="trackLayer.visualDuration"
      />, 🎙 =
      <span
        class="n"
        :class="{
          e: maxLayerDuration === trackLayer.audioDuration,
        }"
        v-text="trackLayer.audioDuration"
      />)
    </i>
  </i>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import fg from '#/libs/FrameGrid';

export default {
  name: 'tmDiagTracks',

  computed: {
    ...mapState('timemachine', ['trackLayer']),
    ...mapGetters('timemachine', ['maxLayerDuration']),

    deltaOfSums() {
      let sumEndStart = 0;
      let sumDuration = 0;

      _.eachIn(this.trackLayer.visual, 'data', (data) => {
        sumEndStart += data.displayEndTime - data.displayStartTime;
        sumDuration += data.displayDuration;
      });

      return fg.trunc(sumEndStart - sumDuration);
    },
  },

  methods: {
    numberClassObj(n) {
      return [
        'n',
        {
          e: fg.isEdge(n),
        },
      ];
    },

    visualFragmentDurationDelta(vt) {
      const delta =
        vt.data.endTime -
        vt.data.startTime -
        (vt.data.displayEndTime - vt.data.displayStartTime);
      return delta < 0.001 ? 0 : delta;
    },

    audioFragmentDurationDelta(vt) {
      const delta =
        vt.data.relativeEndTime -
        vt.data.relativeStartTime -
        (vt.data.displayEndTime - vt.data.displayStartTime);
      return delta < 0.001 ? 0 : delta;
    },
  },
};
</script>

<style lang="scss">
.tm-diag .tm-diag-tracks {
  position: fixed;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
  z-index: var(--tm-zDiagTracks);
  padding: 2px 4px;
  background-color: rgba(#fff, 0.5);
  color: #000;
  box-shadow: 0 0 4px rgba(#000, 0.2);
  min-width: 300px;
  opacity: 0.7;

  > .-tracks {
    display: flex;
    .i {
      min-width: 20px;
    }
  }
  .n {
    min-width: 50px;
    &.e {
      font-weight: 600;
    }
  }
}
</style>
